import { render, staticRenderFns } from "./AboutPageMediaComponent.vue?vue&type=template&id=e2c219f8&scoped=true&"
import script from "./AboutPageMediaComponent.vue?vue&type=script&lang=ts&"
export * from "./AboutPageMediaComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AboutPageMediaComponent.vue?vue&type=style&index=0&id=e2c219f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c219f8",
  null
  
)

export default component.exports